import { API_URL as API, BACKEND_URL } from '../utils/config';
import React, { useState } from 'react';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';
import { toast } from 'sonner';
import { Mail, MapPin } from 'lucide-react';


const Contact = () => {
  const { t, language } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, formData);
      toast.success(t('messageSent'));
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      toast.error('Failed to send message');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7] pt-32 pb-24" data-testid="contact-page">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <h1 className="text-lg font-sans font-bold uppercase tracking-tight leading-none text-[#1A1A1A] mb-12 text-center">
          {t('contactUs')}
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div>
            <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-[#1A1A1A] mb-2 block">
                  {t('yourName')}
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className="w-full bg-transparent border-b border-[#1A1A1A]/20 focus:border-[#1A1A1A] py-3 px-0 text-[#1A1A1A] placeholder:text-[#1A1A1A]/40 focus:ring-0 focus:outline-none transition-colors"
                  data-testid="name-input"
                />
              </div>

              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-[#1A1A1A] mb-2 block">
                  {t('yourEmail')}
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="w-full bg-transparent border-b border-[#1A1A1A]/20 focus:border-[#1A1A1A] py-3 px-0 text-[#1A1A1A] placeholder:text-[#1A1A1A]/40 focus:ring-0 focus:outline-none transition-colors"
                  data-testid="email-input"
                />
              </div>

              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-[#1A1A1A] mb-2 block">
                  {t('yourMessage')}
                </label>
                <textarea
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  required
                  rows="6"
                  className="w-full bg-transparent border-b border-[#1A1A1A]/20 focus:border-[#1A1A1A] py-3 px-0 text-[#1A1A1A] placeholder:text-[#1A1A1A]/40 focus:ring-0 focus:outline-none transition-colors resize-none"
                  data-testid="message-textarea"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="bg-[#1A1A1A] text-white px-8 py-4 text-xs uppercase tracking-[0.2em] hover:bg-[#333333] transition-all duration-300 disabled:opacity-50"
                data-testid="submit-btn"
              >
                {loading ? 'Sending...' : t('sendMessage')}
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div className="flex flex-col justify-center space-y-8">
            <div className="flex items-start gap-4">
              <Mail className="w-6 h-6 text-[#C6A87C] flex-shrink-0" />
              <div>
                <h3 className="text-sm uppercase tracking-[0.2em] text-[#1A1A1A] mb-2">
                  {language === 'no' ? 'E-post' : 'Email'}
                </h3>
                <p className="text-base text-[#8A8A8A]">
                  post@cosmobeauty.no
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <MapPin className="w-6 h-6 text-[#C6A87C] flex-shrink-0" />
              <div>
                <h3 className="text-sm uppercase tracking-[0.2em] text-[#1A1A1A] mb-2">
                  {language === 'no' ? 'Besøk oss' : 'Visit Us'}
                </h3>
                <p className="text-base text-[#8A8A8A]">
                  Norway
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;